{
  "slug": "low-iq-scores-explained",
  "title": "IQ स्कोर के लिए निम्नलिखित मानदंड हैं।",
  "description": "निम्न आईक्यू स्कोर रेंज, विश्वास अंतराल, अनुकूलनशील कार्यक्षमता और एक स्कोर अकेले कभी भी एक व्यक्ति को परिभाषित नहीं करता है या एक निदान स्थापित करता है।",
  "summary": "एक निम्न IQ परिणाम एक मानक समूह के सापेक्ष चुने गए कार्यों पर प्रदर्शन का वर्णन करता है। इसे अनिश्चितता, पहुँच की आवश्यकताओं, विकास और दैनिक कार्यों के साथ सावधानीपूर्वक, सम्मानजनक व्याख्या की आवश्यकता होती है।",
  "category": "आईक्यू स्कोर व्याख्या",
  "sections": [
    {
      "heading": "निम्न अंक का क्या मतलब हो सकता है और नहीं हो सकता है",
      "paragraphs": [
        "एक औसत पर-100, एसडी-15 स्केल, अंक नीचे 85 जनसंख्या औसत से नीचे हैं और स्कोर के पास हैं 70 इस से नीचे दो मानक विचलन के आसपास हैं. सटीक प्रतिशत और वर्गीकरण उपकरण तथा मानकों पर निर्भर करता है.",
        "परिणाम मानव मूल्य, दयालुता, रचनात्मकता, व्यावहारिक अनुभव, या हर क्षमता को माप नहीं करता है।"
      ]
    },
    {
      "heading": "एक निदान केवल आईक्यू से नहीं किया जाता है",
      "paragraphs": [
        "बौद्धिक विकलांगता के पेशेवर मूल्यांकन में वैचारिक, सामाजिक और व्यावहारिक जीवन क्षेत्रों में अनुकूलनात्मक कार्य करने के साथ बौद्धिक कार्य करने की क्षमता को भी ध्यान में रखा जाता है, जिसका प्रारंभ विकासात्मक अवधि के दौरान होता है।",
        "एक योग्य मूल्यांकक उपयुक्त उपायों का चयन करता है, आवास और पृष्ठभूमि पर विचार करता है, विश्वसनीय अंतराल की जांच करता है और एक से अधिक स्रोतों से जानकारी एकीकृत करता है।"
      ]
    },
    {
      "heading": "समर्थन की आवश्यकताओं को समझने के लिए परिणामों का उपयोग करें",
      "paragraphs": [
        "स्पष्ट निर्देश, अतिरिक्त समय जब उपयुक्त हो, सहायक प्रौद्योगिकी, शिक्षा, और पर्यावरण परिवर्तन महत्वपूर्ण हो सकते हैं।",
        "यदि एक कम परिणाम अप्रत्याशित है या सेवाओं को प्रभावित कर सकता है, तो एक योग्य पेशेवर के साथ इस पर चर्चा करें, बजाय बार-बार ऑनलाइन परीक्षण लेने या एक कट-ऑफ को पूरी तरह से सटीक के रूप में व्यवहार करने के।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "नीचे एक आईक्यू है 70 आपका मतलब है कि आप बुद्धिहीन हैं?",
      "answer": "न. निदान के लिए अनुकूलनात्मक कार्य और विकासात्मक इतिहास का मूल्यांकन भी आवश्यक है, उपयुक्त पेशेवर मानकों का उपयोग करते हुए।"
    },
    {
      "question": "क्या परीक्षण की स्थिति में स्कोर कम हो सकता है?",
      "answer": "हाँ. थकान, बीमारी, चिंता, भाषा असमानता, ध्यान भटकाने, पहुँच बाधाओं, और अन्य परिस्थितियों प्रदर्शन प्रभावित कर सकते हैं."
    }
  ],
  "related": ["iq-80-meaning", "iq-score-ranges-explained", "how-is-iq-measured"],
  "sources": [
    {
      "label": "1. नैतिकता - नैतिकता के प्रश्नों और उत्तरों का संग्रह।",
      "url": "https://www.aaidd.org/docs/default-source/intellectualdisability/12th-ed-twenty-questions-faq.pdf"
    },
    {
      "label": "पीरसन - डब्ल्यूएआईएस-5 नमूना अंक रिपोर्ट",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
